export const MAXIMUM_VOLUME_POINTS = 15 * 24;
